import { Post } from "./ApiBase";

export async function PostRemoveAllResumes() {
    return await Post("/api/RemoveAllResumes", {});
}

export async function PostRemoveAccount() {
    return await Post("/api/RemoveAccount", {});
}